
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/post/private/[id]",
      function () {
        return require("private-next-pages/post/private/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/post/private/[id]"])
      });
    }
  